module.exports = __webpack_public_path__ + "static/media/startpage_image.3d6aa423.png";